import rpc from '@square/web-rpc-client/rpc';
export default function emberRpc(input = {}) {
    function alwaysWait() {
        return false;
    }
    function beforeRequest() {
        if (typeof Ember !== 'undefined') {
            Ember.Test &&
                Ember.Test.registerWaiter &&
                Ember.Test.registerWaiter(alwaysWait);
        }
    }
    function afterResponse() {
        if (typeof Ember !== 'undefined') {
            Ember.Test &&
                Ember.Test.unregisterWaiter &&
                Ember.Test.unregisterWaiter(alwaysWait);
        }
    }
    return rpc(input.urlForMethod, input.loggerFactory, input.errorDeserializer, input.additionalHeaders, input.responseParser, input.sendSpeleoTraceId, beforeRequest, afterResponse, input.signal);
}
